// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .booking-done[data-v-6851c480]  .ag-theme-balham .ag-selection-checkbox {\n  padding-left: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
